import a11yFocusTrap from 'Helpers/focusTrap.js';

const DashboardControl = () => {
  const dashboardCtrl = document.querySelector('.dashboard-control');

  if (dashboardCtrl) {
    const controlLinkBtns = document.querySelectorAll('.js-wt-control-link');
    const duplicateBtn = document.querySelectorAll('.js-wt-duplicate');

    if (duplicateBtn) {
      duplicateBtn.forEach(btn => {
        btn.addEventListener('click', e => {
          dataLayerPush(e);
          initDuplicateModal(e);
        });
      });
    }

    if (controlLinkBtns) {
      controlLinkBtns.forEach(btn => {
        btn.addEventListener('click', e => {
          dataLayerPush(e);
          window.location = btn.dataset.link;
        });
      });
    }
  }

  // DataLayer
  function dataLayerPush(e) {
    const target = e.currentTarget;

    window.dataLayer.push({
      event: 'profile',
      eventType: target.getAttribute('data-card-action'),
      cardTitle: target.getAttribute('data-card-title'),
      cardType: target.getAttribute('data-card-type'),
    });
  }

  // Duplicate Action
  function initDuplicateModal(e) {
    const duplicateModal = document.querySelector('.js-modal--duplicate');
    const { link } = e.target.dataset;

    if (duplicateModal) {
      toggleModal(true, duplicateModal);
    }

    // Register actions
    const yesBtn = duplicateModal.querySelector('.wt-confirm-modal__cta-1');
    const noBtn = duplicateModal.querySelector('.wt-confirm-modal__cta-2');

    if (yesBtn) {
      yesBtn.addEventListener('click', () => {
        window.location = `${ link }?context=duplicate`;
      });
    }

    if (noBtn) {
      noBtn.addEventListener('click', () => {
        toggleModal(false, duplicateModal);
      });
    }
  }

  // Remove Action

  // TODO: Can be separated in own Modal module
  function toggleModal(isOpen, elem) {
    const body = document.querySelector('body');
    const closeBtn = document.querySelector('.wt-modal__close');

    if (closeBtn) {
      closeBtn.addEventListener('click', close);
    }

    if (isOpen) {
      open();
    } else {
      close();
    }

    function open() {
      body.style.overflow = 'hidden';
      elem.classList.add('is-visible');
      elem.setAttribute('aria-hidden', 'false');
      elem.setAttribute('tabindex', '0');

      a11yFocusTrap.trapFocus(elem, document.activeElement);
    }

    function close() {
      body.style.overflow = 'auto';
      elem.classList.remove('is-visible');
      elem.setAttribute('aria-hidden', 'true');
      elem.setAttribute('tabindex', '-1');
      a11yFocusTrap.unTrapFocus();
    }
  }
};

export default DashboardControl;
